<template>
  <div class="pad-version-container">
    <h2 class="page-title">PAD版本管理</h2>
    
    <div class="pad-version-content">
      <!-- 左侧版本列表 -->
      <el-card class="version-list-card">
        <template slot="header">
          <div class="card-header">
            <span class="card-title">版本列表</span>
          </div>
        </template>
        
        <div class="version-cards">
          <el-card 
            v-for="(item, index) in versionList" 
            :key="index" 
            class="version-card"
            :body-style="{ padding: '15px' }"
          >
            <div class="version-card-header">
              <div class="version-info">
                <span class="version-number">{{ item.version }}</span>
                <span class="version-name">{{ item.name }}</span>
              </div>
              <span class="create-time">{{ item.created_at }}</span>
            </div>
            <div class="version-card-body">
              <div class="version-field">
                <label>提示标题：</label>
                <span>{{ item.title }}</span>
              </div>
              <div class="version-field">
                <label>提示内容：</label>
                <span class="content-text">{{ item.content }}</span>
              </div>
            </div>
          </el-card>
          <div v-if="versionList.length === 0" class="empty-list">
            <el-empty description="暂无版本信息" />
          </div>
        </div>
      </el-card>
      
      <!-- 右侧表单 -->
      <el-card class="version-form-card">
        <template slot="header">
          <div class="card-header">
            <span class="card-title">版本编辑</span>
          </div>
        </template>
        
        <el-form :model="formData" label-width="100px" class="pad-version-form">
          <el-form-item label="版本号">
            <el-input-number 
              v-model="formData.version" 
              placeholder="请输入版本号" 
              size="medium"
              :min="0"
              :precision="0"
              :controls="false"
              style="width: 100%"
            />
          </el-form-item>
          
          <el-form-item label="版本名">
            <el-input v-model="formData.name" placeholder="请输入版本名" size="medium" />
          </el-form-item>
          
          <el-form-item label="提示标题">
            <el-input v-model="formData.title" placeholder="请输入提示标题" size="medium" />
          </el-form-item>
          
          <el-form-item label="提示内容">
            <el-input 
              v-model="formData.content" 
              type="textarea" 
              placeholder="请输入提示内容" 
              :rows="4" 
              size="medium" 
            />
          </el-form-item>
          
          <el-form-item class="form-actions">
            <el-button 
              type="primary" 
              size="medium" 
              @click="saveForm" 
              :loading="loading"
            >
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getPadVersionList, createPadVersion } from '@/api/pad-version';

export default {
  data() {
    return {
      formData: {
        version: 0,
        name: '',
        title: '',
        content: ''
      },
      versionList: [],
      loading: false
    };
  },
  mounted() {
    this.fetchPadVersion();
  },
  methods: {
    async fetchPadVersion() {
      this.loading = true;
      try {
        const data = await getPadVersionList();
        this.versionList = data || [];
        if (data && data.length > 0) {
          // 回显第一条数据，版本号转换为数字
          this.formData = {
            version: Number(data[0].version) || 0,
            name: data[0].name || '',
            title: data[0].title || '',
            content: data[0].content || ''
          };
        }
      } catch (error) {
        console.error('获取PAD版本信息失败:', error);
        this.$message({ message: "获取数据失败" });
      } finally {
        this.loading = false;
      }
    },
    async saveForm() {
      this.loading = true;
      try {
        await createPadVersion(this.formData);
        this.$message({ message: "保存成功" });
        // 保存成功后刷新版本列表
        this.fetchPadVersion();
      } catch (error) {
        console.error('保存PAD版本信息失败:', error);
        this.$message({ message: "保存失败" });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.pad-version-container {
  padding: 30px;
  width: 100%;
  background-color: #f0f2f5;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
}

.pad-version-content {
  display: flex;
  gap: 20px;
}

.version-list-card,
.version-form-card {
  flex: 1;
  min-width: 400px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.version-list-card {
  max-height: 600px;
  overflow-y: auto;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.version-cards {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.version-card {
  transition: all 0.3s ease;
}

.version-card:hover {
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.version-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.version-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.version-number {
  font-size: 14px;
  font-weight: 600;
  color: #409eff;
  background-color: #ecf5ff;
  padding: 2px 8px;
  border-radius: 4px;
}

.version-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.create-time {
  font-size: 12px;
  color: #909399;
}

.version-card-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.version-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.version-field label {
  font-size: 12px;
  font-weight: 500;
  color: #606266;
}

.version-field span {
  font-size: 13px;
  color: #303133;
  line-height: 1.4;
}

.content-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empty-list {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  background-color: #fafafa;
  border-radius: 4px;
}

.version-form {
  flex: 1;
  min-width: 400px;
}

.pad-version-form {
  margin-top: 0;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .pad-version-content {
    flex-direction: column;
  }
  
  .version-list-card,
  .version-form-card {
    min-width: 100%;
  }
  
  .version-list-card {
    max-height: 300px;
  }
}

@media (max-width: 768px) {
  .pad-version-container {
    padding: 15px;
  }
  
  .page-title {
    font-size: 18px;
  }
  
  .el-form-item {
    margin-bottom: 15px;
  }
}
</style>